'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isServer = typeof window === "undefined";

exports["default"] = isServer;
//# sourceMappingURL=isServer.js.map
